"use client";
import React, { memo } from "react";
import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/CoPilot/360Reports/ReportItem/ReportCatalog";

const I18n = I18nUtil.createScoped(Translations);

interface ReportCatalogProps {
  /** 目录列表数据 */
  catalog: {
    id: string;
    title: string;
  }[];
  /** 自定义类名 */
  className?: string;
}

/**
 * ReportCatalog 报告目录组件
 * 显示报告的内容目录列表，包含标题和目录项
 *
 * @param props ReportCatalogProps
 * @returns React.ReactElement
 */
export const ReportCatalog: React.FC<ReportCatalogProps> = memo(
  ({ catalog, className }) => {
    if (!catalog || catalog.length === 0) {
      return null;
    }

    return (
      <div
        className={cn(
          "self-start border border-border_white_transparent10 md:max-h-[440px] md:overflow-y-scroll no-scrollbar",
          "rounded-2 py-3 flex flex-col md:gap-6 gap-2 max-w-[195px] h-auto",
          className,
        )}
      >
        {/* 标题 */}
        <h4
          aria-label="Report Catalog h4"
          data-openreplay-label="Report Catalog h4 Semantic"
          id="sem-report-catalog-h4"
          className="title_l text-content_primary px-4"
        >
          {I18n.t("Content")}
        </h4>
        {/* 目录列表 */}
        <ul className="flex flex-col md:gap-4 gap-3 px-5">
          {catalog.map((item) => (
            <li
              key={item.id}
              className="md:title_m title_s text-content_secondary"
            >
              {item.title}
            </li>
          ))}
        </ul>
      </div>
    );
  },
);

ReportCatalog.displayName = "ReportCatalog";
